<svelte:head>
  <title>Create need | A Good Thing</title>
</svelte:head>

<h2 class="title">Create a need</h2>

<NeedsEditor {data} bind:isValid />

<div class="columns">
  <div class="column">
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          class:is-loading={isLoadingFinish}
          disabled={!isValid}
          on:click={() => create(true)}>Submit</button>
        &nbsp;
        <button
          class="button"
          class:is-loading={isLoadingSave}
          disabled={!isValid}
          on:click={() => create(false)}>Save for later</button>
      </div>
    </div>
  </div>
  <div class="column is-3" />
</div>

{#if errorMessage}
  <div class="notification is-danger is-light">{errorMessage}</div>
{/if}

<script lang="ts">
  import { appState } from '../../../lib/appState';
  import { goto } from '@sveltech/routify';
  import { logging } from '../../../lib/logging';

  import NeedsEditor from '../_components/NeedsEditor.svelte';

  let isValid = true;
  let errorMessage: string;
  let isLoadingFinish = false;
  let isLoadingSave = false;

  let data = {
    title: '',
    charity: $appState.user!.charity!,
    charityDetails: {
      name: $appState.charity!.name
    },
    category: '',
    needs: '',
    benefits: '',
    background: '',
    status: 'draft' as NeedStatus
  } as Need_v1;

  async function create(finish: boolean) {
    if (finish) {
      isLoadingFinish = true;
    } else {
      isLoadingSave = true;
    }

    if(!data.title) {
      data.title = 'Untitled'
    }

    const id = await window.firebase
      .functions()
      .httpsCallable('api-need-createneed')({ need: data, publish: finish } as CreateNeedParams)
      .then((result) => result.data.id)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => {
        isLoadingSave = false;
        isLoadingFinish = false;
      });

    if (finish) {
      $goto('../../need/' + id);
    } else {
      $goto('../../needs/');
    }
  }
</script>
